import axios from '../axios'
import qs from "qs";

function service(endpoint) {
    function resend(id, data = {}) {
        return axios.get(`${endpoint}/${id}/resend`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function refresh(id, data = {}) {
        return axios.get(`${endpoint}/${id}/refresh`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        resend,
        refresh
    }
}

export default service
